import fetchApi from "./fetch";
export type RemnatsProps = {
  article: string;
  name: string;
  is_combo: boolean;
  product_remnants: {
    remnant: number;
    last_remnant_update_at?: string | null;
    reserved_in_ali: number;
    reserved_in_ozon: number;
    reserved_in_ozon_fresh: number;
    reserved_in_sber: number;
    reserved_in_wildberries: number;
    reserved_in_ya: number;
    reserved_in_combo: number;
    share_in_ali: string | null;
    share_in_ozon: string | null;
    share_in_sber: string | null;
    share_in_wildberries: string | null;
    share_in_ya: string | null;
    share_in_combo: string | null;
    show_for_distribution: boolean;
  };
  comboComposition?: { article: string; value: number }[];
  wb_data?: {
    disabled_for_send: boolean;
    last_stock?: number | null;
    new_stock?: number | null;
    need_update_stock?: boolean | null;
    last_update?: string | null;
    barcode?: string | null;
    mp_stock?: number | null;
    mp_stock_sync_at?: string | null;
    quarantine_at?: string | null;
    quarantine_reason?: string | null;
    sync_error?: string | null;
    sync_error_at?: string | null;
    retirement_state?: string | null;
  };
  ozon_data?: {
    disabled_for_send: boolean;
    quarantine_at?: string | null;
    quarantine_reason?: string | null;
    sync_error?: string | null;
    sync_error_at?: string | null;
    retirement_state?: string | null;
    last_stock?: number | null;
    new_stock?: number | null;
    need_update_stock?: boolean | null;
    last_update?: string | null;
    mp_present?: number | null;
    mp_free_stock?: number | null;
    mp_reserved?: number | null;
    mp_warehouse_sync_at?: string | null;
  };
  ya_data?: {
    disabled_for_send: boolean;
    last_stock?: number | null;
    new_stock?: number | null;
    need_update_stock?: boolean | null;
    last_update?: string | null;
  };
  sber_data?: {
    disabled_for_send: boolean;
    last_stock?: number | null;
    new_stock?: number | null;
    need_update_stock?: boolean | null;
    last_update?: string | null;
  };
  ali_data?: {
    disabled_for_send: boolean;
    last_stock?: number | null;
    new_stock?: number | null;
    need_update_stock?: boolean | null;
    last_update?: string | null;
  };
};

export const getRemnants = async () => {
  const result = await fetchApi("/api/product_remnants", {
    method: "GET",
  });
  const data = (await result.json()) as RemnatsProps[];
  return data;
};

export const patchRemnants = async (
  props: { article: string; data: Partial<RemnatsProps["product_remnants"]> }[]
) => {
  const result = await fetchApi("/api/product_remnants", {
    method: "PATCH",
    body: JSON.stringify(props),
  });
  const data = (await result.json()) as RemnatsProps[];
  return data;
};

export const manualSend = async (props: { article: string }[]) => {
  const result = await fetchApi("/api/product_remnants/manual_send", {
    method: "post",
    body: JSON.stringify(props),
  });
  const data = await result.json();
  return data;
};

export const updateMPData = async (
  props: {
    article: string;
    wb_data?: {
      disabled_for_send?: boolean;
      quarantine_at?: string | null;
      need_update_stock?: boolean;
    };
    ozon_data?: {
      disabled_for_send?: boolean;
      quarantine_at?: string | null;
      need_update_stock?: boolean;
    };
    ya_data?: { disabled_for_send?: boolean; need_update_stock?: boolean };
    sber_data?: { disabled_for_send?: boolean; need_update_stock?: boolean };
    ali_data?: { disabled_for_send?: boolean; need_update_stock?: boolean };
  }[]
) => {
  const result = await fetchApi("/api/product_remnants/updateMPData", {
    method: "post",
    body: JSON.stringify(props),
  });
  const data = await result.json();
  return data;
};

export const retireMp = async (
  props: {
    article: string;
    marketplace: "wildberries" | "ozon";
    action: "retire" | "return";
  }[]
) => {
  const result = await fetchApi("/api/product_remnants/retire_mp", {
    method: "post",
    body: JSON.stringify(props),
  });
  return await result.json();
};

export const getRemnantsXlsx = async () => {
  const result = await fetchApi("/api/product_remnants/xlsx", {
    method: "get",
  });

  return result;
};
